import React, { createContext, useContext, useState } from "react";

const RadioSelectionsContext = createContext();

export const RadioSelectionsProvider = ({ children }) => {
  const [radioSelections, setRadioSelections] = useState([]);

  return (
    <RadioSelectionsContext.Provider value={{ radioSelections, setRadioSelections }}>
      {children}
    </RadioSelectionsContext.Provider>
  );
};

export const useRadioSelections = () => {
  const context = useContext(RadioSelectionsContext);
  if (!context) {
    throw new Error("useRadioSelections must be used within a RadioSelectionsProvider");
  }
  return context;
};